const caCurrencyOnly: { [key: string]: string } = {
  CAD: 'CAD',
};

export default caCurrencyOnly;
